import React from 'react'
import styles from './SignupPrompt.scss'
import { Topo } from 'common/styleguide/Topo'
import { CTA } from 'common/styleguide/CTA'
import { Msg, commonCTAs } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export class SignupPrompt extends React.PureComponent {
  render () {
    return (
      <Topo mint className={styles.SignupPrompt}>
        <h2><T id='SignupPrompt.likeIt' defaultMessage='Like What You See?' /></h2>
        <div>
          <T
            id='SignupPrompt.signUp'
            defaultMessage='Sign up for a free Ride with GPS account to save this ride and send to your device.' />
        </div>
        <CTA primary href={`/signup?redirect=${encodeURIComponent(window.location.href)}`}>
          <Msg capitalized m={commonCTAs.signUp} />
        </CTA>
      </Topo>
    )
  }
}
